import { IsOptional, IsString } from 'class-validator';

export class MerchantSorting {
  @IsOptional()
  @IsString()
  latitude?: string;

  @IsOptional()
  @IsString()
  longitude?: string;

  @IsOptional()
  @IsString()
  address?: string;
}